import { Injectable } from '@angular/core';
import {BaseApiService} from "../../common/base-api.service";
import {HttpClient} from "@angular/common/http";
import {SettingsProviderService} from "../../common/settings-provider.service";
import {Observable} from "rxjs";
import {IObservation} from "../../message-models/observation.interface";
import {ITrainingType} from "../../message-models/training-record-type.interface";
import {ITrainingRecord} from '../../message-models/training-record.interface';
import {IOperativeObservation} from '../../message-models/operative-observation.interface';
import {ITrainingRecordSummary} from '../../message-models/training-record-summary.interface';
import { ITrainingMatrix } from '../../message-models/training-matrix.interface';

@Injectable({
  providedIn: 'root'
})
export class TrainingRecordsService extends BaseApiService {

  constructor(http:HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'TrainingRecords');
  }

  getTrainingTypesForCompany(companyId: string, includeGlobal: boolean = true): Observable<ITrainingType[]> {
    return this.post<ITrainingType[]>('GetTrainingTypesForCompany', {companyId, includeGlobal});
  }

  getTrainingRecordsForOperative(operativeId: string): Observable<ITrainingRecord[]>{
    return this.post<ITrainingRecord[]>('GetTrainingRecordsForOperative',{operativeId});
  }

  getTrainingRecordById(trainingRecordId: string): Observable<ITrainingRecord>{
    return this.post<ITrainingRecord>('GetTrainingRecord',{trainingRecordId});
  }

  getTrainingRecordSummariesForOperative(operativeId: string): Observable<ITrainingRecordSummary[]>{
    return this.post<ITrainingRecordSummary[]>('GetTrainingRecordSummariesForOperative',{operativeId});
  }

  createOrUpdateTrainingRecord(iTrainingRecord: ITrainingRecord){
    return this.post<ITrainingRecord>('CreateOrUpdateTrainingRecord',iTrainingRecord);
  }

  createOrUpdateCompanyTrainingType(newTrainingType: ITrainingType): Observable<ITrainingType>{
    return this.post<ITrainingType>('CreateOrUpdateCompanyTrainingType', newTrainingType);
  }

  createOrUpdateGeneralTrainingType(newTrainingType: ITrainingType): Observable<ITrainingType>{
    return this.post<ITrainingType>('CreateOrUpdateGeneralTrainingType', newTrainingType);
  }

  deleteTrainingType(trainingType: ITrainingType): Observable<boolean>{
    return this.post<boolean>('DeleteTrainingType', trainingType);
  }

  deleteTrainingRecord(trainingRecord: ITrainingRecord): Observable<boolean>{
    return this.post<boolean>('DeleteTrainingRecord', trainingRecord);
  }


  getTrainingRecordSummariesForCompany(companyId: string): Observable<ITrainingRecordSummary[]>{
    return this.post<ITrainingRecordSummary[]>('GetTrainingRecordSummariesForCompany', { companyId });
  }

  getTrainingTypesForId(trainingTypeId: string): Observable<ITrainingType> {
    return this.post<ITrainingType>('GetTrainingTypesForId', { trainingTypeId });
  }

  getTrainingMatrixForCompany(companyId: string): Observable<ITrainingMatrix[]> {
    return this.post<ITrainingMatrix[]>('GetTrainingMatrixForCompany', { companyId });
  }

}
